import React, { Component } from "react";
import { Toast, List, InputItem, Button ,Icon} from "antd-mobile";
import { setItem, fixIOSWXBug, removeItem } from "../../util/util";
import http from "../../util/api";
import Countdown from "../../components/Countdown";
import { createForm } from "rc-form";
import { privacy } from "../../util/privacy";
import qs from "qs";
import "./Login.scss";

const { Fragment } = React;

/**
 * 登录
 */
class Login extends Component {
  state = {
    hasGetVerCodeBtn: true,
    showPrivacy:false
  };

  componentDidMount = async () => {
    this.from = this.props.location.state && this.props.location.state.from;
    removeItem("submit");
    removeItem("signature");
    removeItem("photoLink");
    removeItem("otherInfo");
    removeItem("famInfo");
    removeItem("workInfo");
    removeItem("eduInfo");
    removeItem("selfInfo");
    removeItem("editInfoTime");
    removeItem("personalInfo");
  };

  handleGetVerifyCode = async () => {
    const { getFieldValue, getFieldError } = this.props.form;
    const phoneNumber = getFieldValue("phoneNumber");
    const hasError = getFieldError("phoneNumber");
    if (!phoneNumber || hasError) {
      return Toast.fail("手机号格式有误", 1);
    }
    let res;

    try {
      res = await http().getVerCode({
        telephone: phoneNumber,
        unionid: this.unionid,
        openid: this.openid
      });
    } catch (err) {
      return Toast.fail(err.message);
    }
    // 获取验证码成功
    if (res.data.error === 0) {
      Toast.info("已发送验证码");
      this.setState({ hasGetVerCodeBtn: false });
    } else {
      Toast.fail(res.data.message);
    }
  };
  //查询用户是否存在
  isUserExist = async (userid) => {
    try {
      let res = await http().isUserExist({ userid });
      return res;
    } catch (error) {
      throw error;
    }
  };

  //注册
  register = async (data) => {
    try {
      let res = await http().register(data);
      return true;
    } catch (error) {
      Toast.fail(
        <React.Fragment>
          <div>登录失败！</div>
          <div>验证码错误</div>
        </React.Fragment>
      );
      return false;
    }
  };
  // 登录
  login = async (data, id) => {
    try {
      let res = await http().login(data);
      if(res.data.ErrorMsg==='短信验证失败'){
        Toast.fail(
          <React.Fragment>
            <div>登录失败！</div>
            <div>验证码错误</div>
          </React.Fragment>
        );
      }else{
        setItem("userInfo", JSON.stringify(res.data));
        Toast.success("登录成功！");
        const search = document.location.search;
        const querystring = search.substring(1);
        const {enterpriseID,jobID,isSHG} = qs.parse(querystring);
        if(isSHG){
          this.props.history.push("/home?isSHG=1"+(enterpriseID?('&enterpriseID='+enterpriseID):'')+(jobID?('&jobID='+jobID):''));
        }else{
          this.props.history.push("/home"+(enterpriseID?('?enterpriseID='+enterpriseID):'')+(jobID?('&jobID='+jobID):''));
        }
      }
    } catch (error) {
      Toast.fail(
        <React.Fragment>
          <div>登录失败！</div>
          <div>验证码错误</div>
        </React.Fragment>
      );
    }
  };
  handleSub =async() =>{
    const { validateFields } = this.props.form;
    validateFields(async (err, values) => {
      if (err) {
        return Toast.fail("信息填写有误");
      }
      const userid = values.phoneNumber;
      let registerData = {
        Handphone:values.phoneNumber, // 手机号
        userid: userid, //身份证号
        // personid: values.idNumber,
        validCode: values.verifyCode, // 验证码
        nickname: values.phoneNumber, // 昵称
        validresid: 616852937051,
        invitecode:'66287175'//验证码
      };
      let loginData = {
        mobileno: values.phoneNumber, // 手机号
        validCode: values.verifyCode, // 验证码
        loginMethod: "mobile",
        useCookie: false,
      };
    Toast.loading();
    let isUserExistResponse = await this.isUserExist(userid);
    if (isUserExistResponse.data.onedata) {
      this.login(loginData, values.idNumber);
    }else{
      let bol=await this.register(registerData);
      if(bol){ this.login(loginData, values.idNumber);}
    }
    })
  }
  render() {
    const { getFieldProps, getFieldError } = this.props.form;
    const { hasGetVerCodeBtn } = this.state;
    return (
      <div style={{ backgroundColor: "#fff", height: "100%" }}>
        <div>
          <div>
            <div>

              <h2
                style={{
                  textAlign: "center",
                  color: "black",
                  fontSize: "1.2rem",
                  padding: "1rem 0 .2rem"
                }}
              >
                <b>招聘助手</b>
              </h2>
            </div>
            <List>
              <InputItem
                placeholder="请输入手机号"
                type="number"
                {...getFieldProps("phoneNumber", {
                  rules: [{ required: true, len: 11 }]
                })}
                error={getFieldError("phoneNumber")}
                extra={
                  <Fragment>
                    {hasGetVerCodeBtn ? (
                      <span
                        className="register__get-verify-code-btn"
                        onClick={this.handleGetVerifyCode}
                        style={{ fontSize: "11pt", color: "black" }}
                      >
                        获取验证码
                      </span>
                    ) : (
                      <Countdown
                        onDownEnd={() =>
                          this.setState({ hasGetVerCodeBtn: true })
                        }
                      />
                    )}
                  </Fragment>
                }
              />
              <InputItem
                onBlur={fixIOSWXBug}
                maxLength={4}
                placeholder="请输入验证码"
                {...getFieldProps("verifyCode", {
                  rules: [{ required: true }]
                })}
                error={getFieldError("verifyCode")}
              />
            </List>
          </div>
          {/* <div style={{ color: "#999", marginTop: "5%", marginLeft: "2%" }}>
            点击登录/注册即视为您已经阅读并同意<span style={{color:'#1890ff'}} onClick={()=>{this.setState({showPrivacy:true});}}>《招聘助手使用协议》</span>
          </div> */}
          <Button
            className="body_register_register-btn"
            type="primary"
            onClick={this.handleSub}
            style={{
              marginTop: "20%",
              fontWeight: "bold",
              width: "90%",
              marginLeft: "5%"
            }}
          >
            登录/注册
          </Button>
        </div>
        {
          this.state.showPrivacy?
          <>
          <Icon type="cross" onClick={()=>{this.setState({showPrivacy:false});}}/>
          <div className='privacy' dangerouslySetInnerHTML={{__html: privacy}}></div>
          </>
        :null
        }
        
      </div>
    );
  }
}

export default createForm()(Login);
